import { alpha, Typography, Box } from '@mui/material'
import colors from 'styles/colors'
import InCardStack, { ColStack } from 'components/atoms/container/InCardStack'
import RowStack from 'components/atoms/container/RowStack'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import NorthIcon from '@mui/icons-material/North'
import SouthIcon from '@mui/icons-material/South'
import { IconContainer } from 'components/atoms/Icons'
import { formatDateShort, formatDate } from 'utils/formatDateTime'
import { ScoreBar } from 'components/atoms/ShadedScoreDisplayBar'
import { useTranslation } from 'react-i18next'

const PercentageChange = ({ percentage }) => {
  const { t } = useTranslation()
  const color = percentage >= 0 ? colors.Green400 : colors.Watermelon400
  return (
    <InCardStack spacing={0} minWidth={80}>
      {percentage ? (
        <>
          <RowStack spacing={0} width={'auto'}>
            <Typography variant='formTagSelected' fontSize={24} color={color}>
              {Math.abs(percentage)}%
            </Typography>

            {percentage !== 0 && (
              <IconContainer
                icon={percentage > 0 ? <NorthIcon /> : <SouthIcon />}
                size={16}
                style={{
                  color: color
                }}
              />
            )}
          </RowStack>
          <Typography variant='formTagSelected' fontSize={11} color={color}>
            {t('assessmentTimeline.change')}
          </Typography>
        </>
      ) : (
        <Typography variant='formTagSelected' fontSize={24}>
          N/A
        </Typography>
      )}
    </InCardStack>
  )
}

export const RoundedScore = ({
  score,
  timestamp,
  backgroundColor,
  borderColor,
  ...otherProps
}) => {
  return (
    <Box
      width={80}
      height={80}
      borderRadius={25}
      backgroundColor={backgroundColor}
      border={`2px solid ${borderColor}`}
      {...otherProps}>
      <InCardStack spacing={0} justifyContent={'center'} height={'100%'}>
        <Typography variant={'h2'} fontSize={22}>
          {score || '-'}
        </Typography>
        <Typography fontSize={11} fontWeight={500} color='textSecondary'>
          {formatDateShort(timestamp)}
        </Typography>
      </InCardStack>
    </Box>
  )
}

export const AverageComparisionCard = ({ displayScores, name }) => {
  const { t } = useTranslation()
  const stateColor = name === 'self' ? colors.Teal400 : colors.MidnightTeal300
  return (
    <BoxWithBackground
      padding={8}
      borderRadius={3}
      backgroundColor={alpha(stateColor, 0.15)}
      width={'100%'}
      maxWidth={320}>
      <ColStack spacing={4}>
        <Typography variant='h5'>
          {name === 'self' ? t('goalsArea.self') : t('goalsArea.others')}
        </Typography>

        <RowStack justifyContent={'space-between'}>
          <PercentageChange percentage={Number(displayScores?.changePercent)} />
          <RowStack spacing={8}>
            <RoundedScore
              score={displayScores?.newScore}
              timestamp={displayScores?.newTimeStamp}
              backgroundColor={alpha(stateColor, 0.2)}
              borderColor={alpha(stateColor, 0.5)}
            />
            <RoundedScore
              score={displayScores?.oldScore}
              timestamp={displayScores?.oldTimeStamp}
              backgroundColor={alpha(stateColor, 0.35)}
              borderColor={alpha(stateColor, 0.5)}
            />
          </RowStack>
        </RowStack>
      </ColStack>
    </BoxWithBackground>
  )
}

export const ScoreBarWrapper = ({ score, date, ...otherProps }) => {
  const { i18n } = useTranslation()
  const labelTypoProps = {
    variant: 'body1Small',
    fontWeight: 500
  }

  return (
    <ScoreBar
      score={score || 0}
      label={formatDate(date, i18n.resolvedLanguage, 'short')}
      labelTypoProps={labelTypoProps}
      scaleStartPosition={0.58}
      {...otherProps}
    />
  )
}
